import { useEffect } from 'react';

const useDocumentVisibilityChange = (cb) => {
  useEffect(() => {
    document.addEventListener('visibilitychange', cb, false);
    return () => document.removeEventListener('visibilitychange', cb, false);
  }, [cb]);
};

export default useDocumentVisibilityChange;
